/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Task } from './task';

export type GenericApiResponseListTaskData = Task[] | null;
